import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postBillingSubscription = async (propData) => {
  const apiURL = API_HOST + '/billing/subscription';
  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.post(apiURL, propData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
